__turbopack_context__.v({
  "tableContainer": "IndicatorTable-web-modal-module__9ZZbiG__tableContainer",
});
